import { DatePicker } from '@mui/lab'
import { DatePickerProps, fieldToDatePicker } from 'formik-mui-lab';
import moment from 'moment';

import React from 'react'

export default function RegistrationDatePicker(props: DatePickerProps) {

  moment.tz.setDefault('GMT')
  const offset = (new Date()).getTimezoneOffset();

  return (
      <DatePicker minDate={moment("2023/06/18").add(-offset, 'minutes')} maxDate={moment("2023/07/03").add(-offset, 'minutes')} {...fieldToDatePicker(props)}></DatePicker>
  )
}
